'use client'

import TermsCluster from '../../../components/common/modal/terms-cluster'
import SubmittedState from '../../../components/ui/submitted-state'
import Text from '../../../components/ui/text'
import { Button } from '../../components/ui/button'
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '../../components/ui/form'
import { fields } from './fields'
import { useFormHook } from '@telesoft/lib/web/use-form-submission'
import { Form as TForm } from '@telesoft/types/payload-types'
import React, { Fragment, useState } from 'react'
import { Input } from '../ui/input'

const CMSFormComponent: React.FC<{ form: TForm; title?: string; resourceID?: string }> = props => {
  const [pdfFile, setPdfFile] = useState<File | null>(null)
  const cmsForm = props.form
  const attachment = cmsForm?.attachment
  const { form, error, isLoading, hasSubmitted, onSubmit } = useFormHook(cmsForm)

  return (
    <div>
      {!isLoading && hasSubmitted && cmsForm.confirmationType === 'message' && (
        <SubmittedState className="" content={cmsForm.confirmationMessage} />
      )}
      {isLoading && !hasSubmitted && <p>Loading, please wait...</p>}
      {error && <div>{`${error.status || '500'}: ${error.message || ''}`}</div>}
      {props?.title && !hasSubmitted && (
        <Text className="mb-8 max-w-xs" variant="heading">
          {props.title}
        </Text>
      )}
      {!hasSubmitted && (
        <Fragment>
          <Form {...form}>
            <form
              className="space-y-4"
              onSubmit={form.handleSubmit(data => {
                const dataWithResourceIDOrAttachment = {
                  ...data,
                  resourceID: props?.resourceID ?? null,
                  attachment: pdfFile,
                }
                return onSubmit({ data: dataWithResourceIDOrAttachment })
              })}
            >
              {cmsForm.fields?.map(fieldItem => {
                const isRequired = 'required' in fieldItem && fieldItem.required
                const Field: React.FC<any> = fields?.[fieldItem.blockType]
                const label = 'label' in fieldItem ? fieldItem.label : null
                return (
                  <>
                    <FormField
                      key={`form-field-${fieldItem.id}`}
                      control={form.control}
                      // @ts-ignore
                      name={'name' in fieldItem ? fieldItem.name! : fieldItem.id}
                      render={({ field }) => (
                        <FormItem>
                          {label && <FormLabel>{isRequired ? `${label}*` : label}</FormLabel>}
                          <FormControl>
                            <Field {...field} {...fieldItem} />
                          </FormControl>
                          <FormMessage />
                        </FormItem>
                      )}
                    />
                  </>
                )
              })}
              {cmsForm?.isUploadField && (
                <FormField
                  control={form.control}
                  // @ts-ignore
                  name={attachment && attachment.name}
                  render={({ field }) => (
                    <FormItem>
                      {attachment && attachment.label && (
                        <FormLabel>
                          {attachment?.required ? `${attachment.label}*` : attachment.label}
                        </FormLabel>
                      )}
                      <FormControl>
                        <Input
                          id="cv"
                          {...field}
                          type="file"
                          accept={'application/pdf'}
                          onChange={e => setPdfFile(e.target.files?.[0] || null)}
                        />
                      </FormControl>
                      <FormMessage />
                    </FormItem>
                  )}
                />
              )}
              <FormItem>
                <Button disabled={isLoading} size={'default'} variant={'default'} type="submit">
                  {cmsForm.submitButtonLabel}
                </Button>
              </FormItem>
            </form>
          </Form>
          <TermsCluster />
        </Fragment>
      )}
    </div>
  )
}

export default CMSFormComponent
